import { render, staticRenderFns } from "./ontick-checkbox.component.vue?vue&type=template&id=1b816624&scoped=true"
import script from "./ontick-checkbox.component.vue?vue&type=script&lang=js"
export * from "./ontick-checkbox.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-checkbox.component.vue?vue&type=style&index=0&id=1b816624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b816624",
  null
  
)

export default component.exports